import { FaFacebookF, FaYoutube, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

function Footer() {
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

  return (
    <footer className="relative overflow-hidden text-white pt-32 pb-8 bg-[#0b0b15]">

      {/* 🔥 GLOW */}
      <div className="absolute left-[-200px] top-0 w-[400px] h-[400px] rounded-full 
      bg-gradient-to-br from-[#ff003c] to-[#6a00ff] opacity-10 blur-[120px] pointer-events-none"></div>

      <div className="absolute right-[-150px] bottom-0 w-[350px] h-[350px] rounded-full 
      bg-gradient-to-tr from-[#ff003c] to-[#6a00ff] opacity-10 blur-[120px] pointer-events-none"></div>

      {/* 🔥 CTA BOX (FINAL POSITION FIX) */}
      {!isLoggedIn && (
       <div className="w-full px-4 -mt-16 sm:-mt-20 md:-mt-24 lg:-mt-28 relative z-10">
          <div className="rounded-2xl w-full max-w-6xl mx-auto overflow-hidden shadow-xl 
          bg-gradient-to-r from-[#ff003c] to-[#6a00ff] p-[1px]">

            <div className="bg-[#141422] rounded-2xl px-8 py-12 flex flex-col lg:flex-row items-center justify-between gap-6">

              <div className="text-center lg:text-left max-w-xl">
                <h2 className="text-3xl font-bold mb-4">
                  Ready To Start Your Journey?
                </h2>
                <p className="text-gray-400">
                  Stop Scrolling, Start Playing. Create your account now and earn 500 coins
                </p>
              </div>

              <button
                onClick={() => navigate('/signin')}
                className="px-10 py-4 font-bold text-lg text-white rounded-xl 
                bg-gradient-to-r from-[#ff003c] to-[#6a00ff]
                hover:scale-105 transition-all duration-300 shadow-lg"
              >
                Play Now!
              </button>

            </div>
          </div>
        </div>
      )}

      {/* ================= FOOTER MAIN ================= */}
      <div className="relative z-10 max-w-6xl mx-auto px-10 mt-10">

        <div className="flex flex-col lg:flex-row justify-between items-center gap-8">

          <div className="flex flex-col lg:flex-row items-center gap-8">
            <img src="./assets/newghana.png" className="h-12 lg:h-14" alt="Logo" />

            <ul className="flex items-center space-x-6 font-semibold cursor-pointer">
              <li onClick={() => navigate('/')} className="hover:text-[#ff003c]">Home</li>
              <li onClick={() => navigate('/games')} className="hover:text-[#ff003c]">Games</li>
              <li onClick={() => navigate('/video')} className="hover:text-[#ff003c]">Videos</li>
              <li onClick={() => navigate('/support')} className="hover:text-[#ff003c]">Support</li>
            </ul>
          </div>

          <div className="flex gap-4">
            <SocialIcon icon={<FaFacebookF />} />
            <SocialIcon icon={<FaYoutube />} />
            <SocialIcon icon={<FaInstagram />} />
            <SocialIcon icon={<FaLinkedinIn />} />
          </div>
        </div>

        <div className="border-t border-[#ffffff10] my-6"></div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
          <p>
            Copyright © ghanagameium | Designed by{" "}
            <span className="text-[#ff003c]">ghanagameium</span>
          </p>

          <div className="flex gap-6">
            <span className="hover:text-white cursor-pointer">Privacy</span>
            <span className="hover:text-white cursor-pointer">Terms & Conditions</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

/* ICON */
const SocialIcon = ({ icon }) => (
  <div className="w-12 h-12 rounded-full bg-[#1f1f35] border border-[#ffffff10] 
  flex items-center justify-center 
  hover:bg-gradient-to-r hover:from-[#ff003c] hover:to-[#6a00ff] 
  transition-all duration-300 cursor-pointer">
    {icon}
  </div>
);

export default Footer;